import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import RenderInputFormGroup from '../common/Form/RenderInputFormGroup'
import RenderPasswordFormGroup from '../common/Form/RenderPasswordFormGroup'
import {required, excludeSymbols} from '../common/Form/rules'
import {capitilize} from '../common/Form/normalize'
// import {TIMEZONES_DATA} from '../../settings/constants'
import moment from 'moment';

const Form = (props, context) => {
    let {handleSubmit, error, submitting, email, isTeacherOrganisation, username, is_organisation, payment_date_active, languages, submitSucceeded, showModalPayment} = props
    let {formatMessage} = context

    return (
        <form className="profile-form" onSubmit={handleSubmit}>
            <div className="row">
                <div className={"col-xs-12 col-sm-6"}>
                    <div className="form-group">
                        <label className="control-label">{formatMessage("User name")}:</label>
                        <p>{username}</p>
                    </div>
                    <Field
                        name = "first-name"
                        type = "text"
                        component = {RenderInputFormGroup}
                        label = {`${formatMessage("First name")}:`}
                        id = "first-name"
                        validate = {[required, excludeSymbols]}
                        normalize = {capitilize}
                        autoComplete="off"
                    />
                    <Field
                        name = "last-name"
                        type = "text"
                        component = {RenderInputFormGroup}
                        label = {`${formatMessage("Last name")}:`}
                        id = "last-name"
                        validate = {[required, excludeSymbols]}
                        normalize = {capitilize}
                        autoComplete="off"
                    />
                    <div className="form-group">
                        <p>{formatMessage("Gender")}:</p>
                        <label className="radio-inline custom-radio">
                            <Field
                                component="input"
                                name="gender"
                                type="radio"
                                id="male"
                                value="1"
                            /> {formatMessage("Male")}
                            <span className="custom-radio-span"></span>
                        </label>
                        <label className="radio-inline custom-radio">
                            <Field
                                component="input"
                                name="gender"
                                type="radio"
                                id="female"
                                value="2"
                            /> {formatMessage("Female")}
                            <span className="custom-radio-span"></span>
                        </label>
                    </div>
                    <div className="form-group">
                        <label className="control-label" htmlFor="language">{formatMessage("Language")}:</label>
                        <Field
                            name="language"
                            className="form-control"
                            id="language"
                            component="select"
                        >
                            {
                                languages.map(({id, name}) => (
                                    <option value = {id} key = {id}>{formatMessage(name)}</option>
                                ))
                            }
                        </Field>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-6">
                    {(!is_organisation && !isTeacherOrganisation) && <div className="form-group">
                        <label className="control-label">{formatMessage("user_date_payment")}:</label>
                        <p className="payment-line">
                            {payment_date_active ? 
                                moment.unix(payment_date_active).format('LLL') : 
                                formatMessage("not_payment")} 
                            <button className="btn btn-success btn-sm" type="button" onClick={() => {showModalPayment(true)}}>{formatMessage('btnPaidProfile')}</button>
                        </p>
                    </div>}
                    <div className="form-group">
                        <label className="control-label">{formatMessage("Email")}:</label>
                        <p>{email}</p>
                    </div>
                    <Field
                        name = "password"
                        type = "password"
                        component = {RenderPasswordFormGroup}
                        label = {`${formatMessage("Current password")}:`}
                        id = "password"
                    />
                    <Field
                        name = "new-password"
                        type = "password"
                        component = {RenderPasswordFormGroup}
                        label = {`${formatMessage("New password")}:`}
                        id = "new-password"
                    />
                    <Field
                        name = "confirm-password"
                        type = "password"
                        component = {RenderPasswordFormGroup}
                        label = {`${formatMessage("Confirm password")}:`}
                        id = "confirm-password"
                    />
                    {/*<div className="form-group">
                        <label className="control-label" htmlFor="timezone">{formatMessage("Timezone")}:</label>
                        <Field
                            name="timezone"
                            className="form-control"
                            id="timezone"
                            component="select"
                        >
                            {
                                TIMEZONES_DATA.map(({id, text}) => (
                                    <option value = {id} key = {id}>{text}</option>
                                ))
                            }
                        </Field>
                    </div>*/}
                </div>
            </div>

            {
                submitSucceeded &&
                <div className="row">
                    <div className="col-xs-12 text-center text-success">{formatMessage("Profile updated")}.</div>
                </div>
            }

            {
                error &&
                <div className="row">
                    <div className="col-xs-12 text-center text-danger">{error}</div>
                </div>
            }

            <div className="row">
                <div className="col-xs-12 col-sm-6 col-sm-offset-3">
                    <div className="form-group">
                        <button className="btn btn-primary btn-block" type="submit" disabled={submitting}>{formatMessage("Save")}</button>
                    </div>
                </div>
            </div>
        </form>
    )
}

Form.contextTypes = {formatMessage: PropTypes.any}

export default Form


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Profile/Form.jsx